import {attachDataTables} from "../../../plugins/datatables";
import {getCsrfToken} from "../../../plugins/get-csrf-token";

export function showAnkieterData(event) {
    const $modal = $('#manage-data-modal');
    const $manageDataButton = event.currentTarget;
    $modal
        .modal('show')
        .find('.modal-content')
        .html('<div class="m-5 text-center">' +
            '<div class="spinner-border mb-3" role="status"></div>' +
            '<strong class="d-block">Loading data, please wait...</strong>' +
            '</div>')
        .load($manageDataButton.getAttribute('data-url'), function (responseText, textStatus) {
            if ('error' === textStatus) {
                return $(this).html(responseText);
            }

            attachDataTables($modal);
        })
    ;
}

export function removeMarkedRows() {
    const $button = $('#manage-data-delete');
    $button
        .attr('disabled', 'disabled')
        .attr('original-title', $button.text())
        .text('Deleting...')
    ;
    $('.marked-for-removing').attr('disabled', 'disabled');
    const url = $button.data('url');
    const $checked = $('.marked-for-removing:checked')
    const table = $('#manage-data-table').DataTable();
    const sessionsForRemoving = $checked.map(function () {
        const $el = $(this);
        return $.ajax(url, {
            data: {
                session: $(this).val(),
            },
            method: 'DELETE',
            headers: {'X-CSRF-TOKEN': getCsrfToken()},
        }).done(function () {
            table.row($el.parents('tr')).remove();
        });
    }).get();
    $.when(...sessionsForRemoving).done(function () {
        $button.text($button.attr('original-title')).removeAttr('disabled').removeAttr('original-title');
        $('.marked-for-removing').removeAttr('disabled');
        table.draw();
    });
}
